
const CredibilitySection = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Designed for legal, medical, and operational environments',
      description: 'Built with the rigor required for high-stakes industries where precision and reliability are non-negotiable.',
      image: 'https://public.readdy.ai/ai/img_res/c96f223f3ffe9406b6db6554e034de93.jpg'
    },
    {
      icon: 'ri-lock-line',
      title: 'Compliance-aware system architecture',
      description: 'Every system is engineered with security, privacy, and regulatory requirements at the foundation.',
      image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20intersecting%20X%20cross%20patterns%20forming%20a%20lock%20shape%20emerald%20green%20and%20teal%20glowing%20geometric%20lines%20on%20deep%20black%20background%20futuristic%20minimal&width=400&height=300&seq=credx2&orientation=landscape'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Reliable, secure, and scalable deployments',
      description: 'Infrastructure designed to grow with your business while maintaining performance and security standards.',
      image: 'https://readdy.ai/api/search-image?query=Scalable%20infrastructure%20visualization%20with%20multiple%20X%20cross%20shapes%20expanding%20outward%20emerald%20green%20glowing%20connection%20points%20on%20dark%20space%20background%20representing%20growth%20and%20expansion&width=400&height=300&seq=credx3&orientation=landscape'
    },
  ];

  return (
    <section className="bg-black py-32 relative overflow-hidden">
      {/* X Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternCred" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="40" y2="40" stroke="#10B981" strokeWidth="0.5" />
              <line x1="40" y1="0" x2="0" y2="40" stroke="#10B981" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternCred)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
            <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest">
              TRUST & PRECISION
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Built for High-Trust Industries
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-zinc-900 rounded-2xl overflow-hidden hover:scale-105 transition-all duration-300 border border-zinc-800 hover:border-emerald-500/30"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-emerald-500/20 backdrop-blur-sm rounded-xl">
                  <i className={`${feature.icon} text-emerald-400 text-2xl`}></i>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-white font-bold text-lg mb-3 leading-snug">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-block px-8 py-4 bg-zinc-900/50 border border-zinc-800 rounded-xl">
            <p className="text-gray-300 text-lg italic">
              This is AI for businesses where mistakes are costly — and performance matters.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
